import { render, staticRenderFns } from "./EventRecordsCCure.vue?vue&type=template&id=32e2ca55&scoped=true"
import script from "./EventRecordsCCure.vue?vue&type=script&lang=ts"
export * from "./EventRecordsCCure.vue?vue&type=script&lang=ts"
import style0 from "./EventRecordsCCure.vue?vue&type=style&index=0&id=32e2ca55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e2ca55",
  null
  
)

export default component.exports